<!-- Modal Product Section -->
<div
  id="selectBarcodeModal"
  class="modal fade barcodeModal admin-form"
  bsModal
  #selectBarcodeModal="bs-modal"
  [config]="{ backdrop: 'static' }"
>
  <div class="modal-dialog" [ngStyle]="{ 'min-width': '550px' }">
    <div class="modal-content">
      <form>
        <div class="modal-header">
          <h6 class="modal-title pull-left">Add Barcode</h6>
          <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="closeSelectBarcodeModal()"
            id="selectBarcode-modal-closeBtn"
          >
            <em class="icon-close"></em>
          </button>
        </div>
        <div class="modal-body my-2 pt-0">
          <div class="container" [formGroup]="barcodeForm">
            <div class="row">
              <div class="col-12">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label> Enter each barcode on a separate line.(maximum of {{ maxLength }} barcodes) </label>
                        <textarea
                          formControlName="barcode"
                          id="barcodeInput"
                          class="custom-textarea form-control"
                          rows="10"
                          [ngClass]="{ 'is-invalid': submittedSelectBarcode && form.barcode?.errors }"
                        ></textarea>
                        <div
                          *ngIf="submittedSelectBarcode && form.barcode.errors?.required"
                          class="invalid-feedback mt-1"
                        >
                          {{ 'ERRORS.REQUIRED' | translate }}
                        </div>
                        <div
                          *ngIf="submittedSelectBarcode && form.barcode.errors?.maxlength"
                          class="invalid-feedback mt-1"
                        >
                          {{ 'ERRORS.MAX_IS' | translate: { value: maxLength } }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-standard"
            (click)="closeSelectBarcodeModal()"
            id="product-modal-cancelBtn"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            id="product-modal-addBtn"
            (click)="saveBarcode()"
            appPreventDoubleClick
          >
            OK
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- End Modal Product Section -->
